/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
 * Smart quantity selector: when the user picks "10+" from the dropdown,
 * hide the <select> and reveal the +/- input starting at 10.
 */
document.addEventListener('change', function (e) {
  var select = e.target;
  if (!select.classList.contains('quantity-selector-smart__select')) return;

  var wrapper = select.closest('[data-quantity-smart]');
  if (!wrapper) return;

  var chosenOption = select.options[select.selectedIndex];
  if (chosenOption.dataset.triggerInput === undefined) return;

  // Disable the select so it no longer submits
  select.disabled = true;
  wrapper.querySelector('.quantity-selector-smart__dropdown-wrap').style.display = 'none';

  // Enable and show the +/- input
  var inputWrap = wrapper.querySelector('[data-smart-input]');
  var input = inputWrap.querySelector('input[name="quantity"]');
  input.disabled = false;
  input.value = 10;
  inputWrap.style.display = '';
  input.focus();
});


(function () {
  function roundRapiDiscounts() {
    const labels = document.querySelectorAll('.rapi-bundles__bar-label:not([data-rounded])');
    labels.forEach(label => {
      const text = label.textContent.trim();
      // Check if it contains '-' and '%' and a decimal point
      if (text.includes('-') && text.includes('%') && text.includes('.')) {
        // Extract the number part (e.g., -62.50)
        const match = text.match(/-?\d+(\.\d+)?/);
        if (match) {
          const originalValue = match[0];
          let roundedValue = Math.round(parseFloat(originalValue));

          // Refinement: If the number ends in 9 (e.g., -69, 49), make it 1 point more (e.g., -70, 50)
          if (Math.abs(roundedValue) % 10 === 9) {
            roundedValue += (roundedValue < 0 ? -1 : 1);
          }

          // Replace the original decimal value with the rounded value
          const newText = text.replace(originalValue, roundedValue);

          if (label.textContent !== newText) {
            label.textContent = newText;
          }
          label.setAttribute('data-rounded', 'true');
        }
      }
    });
  }

  // Observe DOM for changes as the widget loads dynamically
  const observer = new MutationObserver((mutations) => {
    roundRapiDiscounts();
  });

  // Only run on product pages
  if (window.location.pathname.includes('/products/')) {
    observer.observe(document.body, { childList: true, subtree: true });

    // Initial run in case elements are already present
    roundRapiDiscounts();
  }
})();

/**
 * Quick-buy drawer gallery: keep the active thumbnail in sync with the
 * currently visible slide using an IntersectionObserver.
 *
 * `openable-element:load:end` is dispatched (bubbles:false) on the
 * quick-buy-drawer element once its content has been injected. We catch
 * it in the capture phase so it reaches us even though it doesn't bubble.
 */
document.addEventListener('openable-element:load:end', function (event) {
  var drawer = event.target;
  if (!drawer || !drawer.classList.contains('drawer--quick-buy')) return;

  var gallery   = drawer.querySelector('.qb-gallery__main');
  var thumbLinks = Array.from(drawer.querySelectorAll('.qb-gallery__thumb-link'));

  if (!gallery || !thumbLinks.length) return;

  var slides = Array.from(gallery.querySelectorAll('.qb-gallery__slide'));
  if (!slides.length) return;

  function setActive(activeId) {
    var target = '#' + activeId;
    thumbLinks.forEach(function (link) {
      link.classList.toggle('is-active', link.getAttribute('href') === target);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        setActive(entry.target.id);
      }
    });
  }, { root: gallery, threshold: 0.5 });

  slides.forEach(function (slide) { io.observe(slide); });
}, true /* capture phase — catches non-bubbling events on descendants */);
/* INKLABS: normalize UpCart drawer upsell image sizes (photos vs plain designs
   have different natural ratios -> uneven card heights). UpCart renders in an
   open shadow root, so we inject a small style sheet into it. */
(() => {
  let tries = 0;
  const inject = () => {
    const host = document.getElementById('upCart');
    if (host && host.shadowRoot) {
      if (!host.shadowRoot.getElementById('inklabs-upcart-img-fix')) {
        const style = document.createElement('style');
        style.id = 'inklabs-upcart-img-fix';
        style.textContent = '#up-upsell-carousel .upcart-upsell-item-image.upcart-upsell-item-image.upcart-upsell-item-image,.upcart-upsell-item-image.upcart-upsell-item-image.upcart-upsell-item-image{aspect-ratio:2/3;height:auto !important;object-fit:cover !important;background:#fff !important;}.upcart-product-image-wrapper.upcart-product-image-wrapper{width:90px !important;min-width:90px !important;border-radius:4px;overflow:hidden;}.upcart-product-image-wrapper.upcart-product-image-wrapper img{width:90px !important;height:128px !important;object-fit:cover !important;}';
        host.shadowRoot.appendChild(style);
      }
      return true;
    }
    return false;
  };
  const timer = setInterval(() => {
    if (inject() || ++tries > 60) clearInterval(timer);
  }, 500);
})();
